import { useFormik } from "formik";
import React, { useState } from "react";
import * as Yup from "yup";
import { frontApi } from "../../api";
import TextInput from "../../components/forms/TextInput";
import TextInputWithButton from "../../components/forms/TextInputWithButton";
import StaticLayout from "../../layouts/StaticLayout";
import { Label } from "recharts";
import { useSearchParams } from 'react-router-dom';

const RedeemCode = () => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const [reward, setReward] = useState("");

  const handleRedeemCode = () => {
    formik.handleSubmit();
  };

  const [searchParams, setSearchParams] = useSearchParams();
  const language = searchParams.get('hl') || "English"
  const prefillCode = searchParams.get('code')

  const rewardLabelEn = {
    PROMO_365_DAYS_SUBSCRIPTION: "1-Year Premium Access",
    PROMO_30_DAYS_SUBSCRIPTION:  "1-Month Premium Access",
    PROMO_7_DAYS_SUBSCRIPTION:   "7-Day Premium Access",
    PROMO_300_GOLD:              "300 Gold",
    PROMO_1750_GOLD:             "1,750 Gold",
    PROMO_3500_GOLD:             "3,500 Gold",
    PROMO_7500_GOLD:             "7,500 Gold",
    PROMO_15000_GOLD:            "15,000 Gold",
    PROMO_32000_GOLD:            "32,000 Gold",
    PROMO_6_GEM:                 "6 Gems",
    PROMO_35_GEM:                "35 Gems",
    PROMO_70_GEM:                "70 Gems",
    PROMO_150_GEM:               "150 Gems",
    PROMO_300_GEM:               "300 Gems",
    PROMO_640_GEM:               "640 Gems",
  };

  const rewardLabelTh = {
    PROMO_365_DAYS_SUBSCRIPTION: "สิทธิ์ Premium 1 ปี",
    PROMO_30_DAYS_SUBSCRIPTION:  "สิทธิ Premium 1 เดือน",
    PROMO_7_DAYS_SUBSCRIPTION:   "สิทธิ Premium 7 วัน",
    PROMO_300_GOLD:              "300 ทอง",
    PROMO_1750_GOLD:             "1,750 ทอง",
    PROMO_3500_GOLD:             "3,500 ทอง",
    PROMO_7500_GOLD:             "7,500 ทอง",
    PROMO_15000_GOLD:            "15,000 ทอง",
    PROMO_32000_GOLD:            "32,000 ทอง",
    PROMO_6_GEM:                 "6 เพชร",
    PROMO_35_GEM:                "35 เพชร",
    PROMO_70_GEM:                "70 เพชร",
    PROMO_150_GEM:               "150 เพชร",
    PROMO_300_GEM:               "300 เพชร",
    PROMO_640_GEM:               "640 เพชร",
  };

  var redeemCode = "Redeem Code"
  var enterUID = "Enter your UID"
  var enterCode = "Enter code"
  var redeem = "Redeem"
  var cannotFindYourID = "Cannot find your UID?"
  var uidDescription = "You can find the UID in the Fitforce2 app by going to Settings > Account and pressing the copy icon"
  var rewardPrefix = "You've got"
  var success = "Success!"
  var ok = "OK"
  var openInventory = "Open the app to view your inventory."

  const errorMessages = language === "Thai" ? {
    "UID not found":                              "ไม่พบรหัสผู้ใช้งาน (UID) นี้ กรุณาตรวจสอบอีกครั้ง",
    "You have already got the reward from this campaign": "บัญชีนี้เคยได้รับสิทธิ์ทดลองเล่นฟรีจากแคมเปญนี้ไปแล้ว",
    "You have already redeemed this reward":      "คุณเคยใช้งานโค้ดนี้ไปแล้ว",
    "Redeem code is out of usage":                "ขออภัย สิทธิ์เต็มจำนวนแล้ว",
    "Invalid redeem code":                        "โค้ดไม่ถูกต้อง กรุณาตรวจสอบและลองอีกครั้ง",
  } : {
    "UID not found":                              "Invalid UID. Please check and try again.",
    "You have already got the reward from this campaign": "Trial offer already used for this account.",
    "You have already redeemed this reward":      "You have already redeemed this reward.",
    "Redeem code is out of usage":                "Sorry, all rewards have been claimed.",
    "Invalid redeem code":                        "Invalid code. Please check and try again.",
  };

  if(language == "Thai")
  {
    redeemCode = "ใช้งานโค้ดพิเศษ"
    enterUID = "กรอกรหัสผู้ใช้"
    enterCode = "กรอกโค้ดพิเศษ"
    redeem = "ใข้งานโค้ด"
    cannotFindYourID = "หารหัสผู้ใช้ไม่เจอ ?"
    uidDescription = "คุณสามารถหา รหัสผู้ใช้ ได้ใน แอพพริเคชั่น Fitforce2 เข้าไปที่ ตั้งค่า > บัญชีผู้ใช้  และกดปุ่มคัดลอก"
    rewardPrefix = "คุณได้รับ"
    success = "สำเร็จ!"
    ok = "ตกลง"
    openInventory = "เปิดแอปเพื่อดูรายการของคุณ"
  }

  const formik = useFormik({
    initialValues: {
      uid: "",
      redeemCode: prefillCode ? prefillCode.toUpperCase() : "",
    },
    validationSchema: Yup.object({
      uid: Yup.string().required("UID is Required"),
    }),
    onSubmit: (values) => {
      const uid = values.uid.trim();
      const redeemCode = values.redeemCode.trim();
      frontApi
        .redeemCode(uid, redeemCode)
        .then((resp) => {
          const label = language === "Thai"
            ? rewardLabelTh[resp.data.Reward]
            : rewardLabelEn[resp.data.Reward];
          setReward(label || resp.data.Reward);
          setShowModal(true)
          formik.setValues({redeemCode: "", uid: uid});
        })
        .catch((e) => {
          if (e?.response?.status === 400) {
            const raw = e?.response?.data?.ErrorMessage;
            const msg = errorMessages[raw] || raw;
            if (raw === "UID not found") {
              formik.setErrors({ uid: msg });
            } else {
              formik.setErrors({ redeemCode: msg });
            }
          } else {
            formik.setErrors({ redeemCode: language === "Thai" ? "เกิดข้อผิดพลาด กรุณาลองอีกครั้ง" : "Something went wrong" });
          }
        })
        .finally(() => setLoading(false));
    },
  });
  
  return (
    <StaticLayout title={redeemCode}>
      <div className="px-8 md:py-8 bg-white bg-opacity-85 rounded-xl">
          <div className="flex flex-col md:flex-row ">
            <div className="flex-[3] p-2 pt-5 md:max-w-[60vh]">
              <label for="uid" class="block mb-2 text-sm lg:text-lg font-bold text-gray-900">UID: </label>
              <TextInput
                placeholder={enterUID}
                name="uid"
                onChange={(e) => formik.setFieldValue("uid", e.target.value.toLowerCase())}
                value={formik.values.uid}
                error={formik.errors.uid}
              />
              <label for="first_name" class="block mb-2 text-sm lg:text-lg font-bold text-gray-900">Redeem code: </label>
              <TextInput
                placeholder={enterCode}
                name="redeemCode"
                onChange={(e) => formik.setFieldValue("redeemCode", e.target.value.toUpperCase())}
                value={formik.values.redeemCode}
                error={formik.errors.redeemCode}
              />
              <button
                onClick={handleRedeemCode}
                className="bg-indigo-600 w-full text-white rounded text-center py-3 mt-4 text-xl lg:text-2xl cursor-pointer disabled:bg-slate-400 disabled:cursor-not-allowed"
                disabled={loading || formik.values.uid === "" || formik.values.redeemCode === ""}
              >
                {redeem}
              </button>
              <div>
                <br></br>
                <p class="text-xl lg:text-2xl text-blue-600 font-semibold">{cannotFindYourID}</p>
                <div class="pt-2"></div>
                <p class="text-gray-600 text-md lg:text-lg">{uidDescription}</p>
                <br></br>
              </div>
            </div>
            <div className="flex-[3] flex justify-center items-center flex-col md:flex-row p-2">
              <div className="flex-1 p-1">
                <img
                  src={require("../../img/Fitforce2/redeem-1.jpg")}
                  alt="redeem-1"
                  className="object-contain"
                />
              </div>              
              <div className="flex-1 p-1">
                <img
                  src={require("../../img/Fitforce2/redeem-2.jpg")}
                  alt="redeem-2"
                  className="object-contain"
                />
              </div>
            </div>
        </div>
      </div>
      <br></br>

      {showModal ? (
        <>
          <div
            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none p-3"
          >
            <div className="relative w-auto my-6 mx-auto max-w-3xl text-black">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none p-6">
                <div className="relative flex-auto content-start p-1">
                  <center>
                    <img alt="success" className="w-24 my-4" src={require("../../img/SuccessCheck.png")}/>
                    </center>
                    <p className="text-lg leading-relaxed font-semibold text-center">
                      {success}
                    </p>
                    <p className="text-sm leading-relaxed text-center">
                      {reward ? `${rewardPrefix} ${reward}` : openInventory}
                    </p>
                </div>
                <div className="flex items-center justify-center pb-6 rounded-b mt-4">
                  <button
                    className="bg-blue-600 text-white active:bg-blue-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 w-40"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    {ok}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </StaticLayout>
  );
};

export default RedeemCode;
